import { post } from '../../service';
import { UrlBuilder } from '../../urlBuilder';

export const getClusters = async (page, pageSize, filters = {}) => {
  const builder = new UrlBuilder(`/admin/clusters/list`);

  try {
    const response = await post(builder.toString(), {
      pageNumber: page,
      perPage: pageSize,
      ...(filters.regionId && { regionId: filters.regionId }),
      ...(filters.precinctId && { precinctId: filters.precinctId }),
    });

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const createCluster = async (payload) => {
  const builder = new UrlBuilder(`/admin/clusters/create`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const updateCluster = async (payload) => {
  const builder = new UrlBuilder(`/admin/clusters/update`);

  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
